import React from 'react';
import './NoticeDetail.css';

function NoticeDetail({ notice, onPrint }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const renderContent = (content) => {
    const lines = content.split('\n');
    const elements = [];
    let currentList = null;
    let listType = null;

    lines.forEach((line, index) => {
      if (line.startsWith('# ')) {
        elements.push(<h1 key={index}>{line.substring(2)}</h1>);
      } else if (line.startsWith('## ')) {
        elements.push(<h2 key={index}>{line.substring(3)}</h2>);
      } else if (line.startsWith('### ')) {
        elements.push(<h3 key={index}>{line.substring(4)}</h3>);
      } else if (line.startsWith('#### ')) {
        elements.push(<h4 key={index}>{line.substring(5)}</h4>);
      } else if (line.match(/^\d+\.\s/)) {
        if (listType !== 'ol') {
          if (currentList) elements.push(currentList);
          currentList = [];
          listType = 'ol';
        }
        currentList.push(<li key={index}>{line.replace(/^\d+\.\s/, '')}</li>);
      } else if (line.startsWith('- ')) {
        if (listType !== 'ul') {
          if (currentList) {
            elements.push(listType === 'ol' ? 
              <ol key={`list-${index}`}>{currentList}</ol> : 
              <ul key={`list-${index}`}>{currentList}</ul>
            );
          }
          currentList = [];
          listType = 'ul';
        }
        currentList.push(<li key={index}>{line.substring(2)}</li>);
      } else if (line.startsWith('> ')) {
        elements.push(<blockquote key={index} style={{
          backgroundColor: '#fff3cd',
          borderLeft: '4px solid #ffc107',
          padding: '12px 20px',
          margin: '20px 0',
          fontWeight: 'bold',
          color: '#856404'
        }}>{line.substring(2).replace(/\*\*/g, '')}</blockquote>);
      } else if (line.startsWith('**') && line.endsWith('**')) {
        elements.push(<p key={index}><strong>{line.slice(2, -2)}</strong></p>);
      } else if (line === '---') {
        elements.push(<hr key={index} />);
      } else if (line.trim() === '') {
        if (currentList) {
          elements.push(listType === 'ol' ? 
            <ol key={`list-${index}`}>{currentList}</ol> : 
            <ul key={`list-${index}`}>{currentList}</ul>
          );
          currentList = null;
          listType = null;
        }
      } else {
        if (currentList) {
          elements.push(listType === 'ol' ? 
            <ol key={`list-${index}`}>{currentList}</ol> : 
            <ul key={`list-${index}`}>{currentList}</ul>
          );
          currentList = null;
          listType = null;
        }
        elements.push(<p key={index}>{line}</p>);
      }
    });

    if (currentList) {
      elements.push(listType === 'ol' ? 
        <ol key="list-final">{currentList}</ol> : 
        <ul key="list-final">{currentList}</ul>
      );
    }

    return elements;
  };

  if (!notice) {
    return (
      <div className="notice-detail empty">
        <p>공고를 선택하면 상세 내용을 확인할 수 있습니다.</p>
      </div>
    );
  }

  return (
    <div className="notice-detail">
      <div className="detail-header">
        <div className="detail-meta">
          <span className="meta-item">공고번호: {notice.id}</span>
          <span className="meta-item">구분: {notice.category}</span>
          <span className="meta-item">공고일: {formatDate(notice.date)}</span>
          <span className="meta-item">최종수정일: {formatDate(notice.lastModified)}</span>
        </div>
        <button onClick={onPrint} className="print-button">
          출력하기
        </button>
      </div>
      
      <div className="detail-content">
        {renderContent(notice.content)}
      </div>
    </div>
  );
}

export default NoticeDetail;